import React, { useEffect, useState } from 'react';
import { Radio, Box, Button, Typography, Select, MenuItem, List, ListItem, ListItemText, IconButton, LinearProgress, Checkbox, FormControlLabel, RadioGroup, FormLabel } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import axiosInstancePromise from '../general/axiosConfig';
import ProgressBarModal from './modales/ProgressBar';

const FileUpload = ({onFileUploadSuccess}) => {
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [uploadStatus, setUploadStatus] = useState('');
    const [uploadProgress, setUploadProgress] = useState(0);
    const [isUploading, setIsUploading] = useState(false);
    const [option, setOption] = useState('');
    const [selectedField, setSelectedField] = useState('');
    const [entidades, setEntidades] = useState([]);
    const [openModalBar, setOpenModalBar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [message, setMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState('success');

    const handleOptionChange = (selectedOption) => {
        setOption(selectedOption);
        setSelectedFiles([]); // Reiniciar archivos seleccionados al cambiar de opción
        setUploadStatus('');
    };

    const handleFileChange = (event) => {
        const files = Array.from(event.target.files);
        const validFiles = files.filter((file) => file.type === 'application/pdf');
        
        if (validFiles.length > 0) {
            setSelectedFiles(prevFiles => [...prevFiles, ...validFiles]);
            setUploadStatus('');
        } else {
            setUploadStatus('Selecciona archivos PDF válidos.');
        }
    };

    const cargarEntidades = async () => {
        try{
            const axiosInstance = await axiosInstancePromise;
            const response = await axiosInstance.get("/get-table-general/DiccionarioClientes");
            const datos = response.data.rows||[];
            setEntidades(datos)
        } catch (error) {
            console.error("Error al cargar las entidades");
        }
        
    };

    const uploadInChunks = async (files, chunkSize = 10) => {
        setIsUploading(true);
        setUploadProgress(0);
        setMessage('Cargando archivos seleccionados...')
        setOpenModalBar(true);

        const totalChunks = Math.ceil(files.length / chunkSize);
        let uploadedChunks = 0;

        for (let i = 0; i < files.length; i += chunkSize) {
            const chunk = files.slice(i, i + chunkSize);
            const formData = new FormData();
            const flagSoportes = option === 'context2'? 'soportes' : '';
            formData.append('id_cliente', selectedField);
            formData.append('flag', flagSoportes || ''); 
            chunk.forEach((file) => formData.append("files", file));
            try {
                const axiosInstance = await axiosInstancePromise;
                await axiosInstance.post("/api/upload", formData, {
                    headers: { "Content-Type": "multipart/form-data" }
                });

                uploadedChunks++;
                setUploadProgress((uploadedChunks / totalChunks) * 100);
            } catch (error) {
                console.error("Error subiendo archivos:", error);
                setUploadStatus("Error al subir los archivos");
                setIsUploading(false);
                
                setSnackbarMessage(`Los archivos NO han sido cargados.`);
                setSnackbarSeverity('error');
                return;
            }
        }
        setUploadProgress(100);
        setUploadStatus("Archivos subidos exitosamente");
        setSelectedFiles([]);
        setIsUploading(false);
        setSnackbarMessage(`Los archivos han sido cargados a la plataforma con éxito.`);
        setSnackbarSeverity('success');
        onFileUploadSuccess();
    };

    const handleFileUpload = () => {
        if (!selectedField) {
            setUploadStatus("Por favor selecciona una entidad antes de subir los archivos.");
            return;
        }
        if (!selectedFiles || selectedFiles.length === 0) {
            setUploadStatus("Por favor selecciona archivos PDF primero.");
            return;
        }
        uploadInChunks(selectedFiles);
    };

    const handleFileDelete = (fileName) => {
        setSelectedFiles(prevFiles => prevFiles.filter(file => file.name !== fileName));
    };

    useEffect(()=>{
        if(uploadStatus) {
            const timer = setTimeout(()=>{
                setUploadStatus("");
            }, 3000);
            return () => clearTimeout(timer);
        }
    }, [uploadStatus]);

    useEffect(()=>{
        cargarEntidades();
    }, []);

    return (
        <Box sx={{ width: '400px', height: 'fit-content', pt: 2, border: '1px solid #ccc', borderRadius: '8px', mt:2, bgcolor:"#e0e0e0",
            display: 'flex', flexDirection: 'column', alignItems: 'center', boxShadow: '-2px 0 5px rgba(0,0,0,0.1)', }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'start' }}>
                <FormLabel component="legend">Tipo de carga</FormLabel>
                <RadioGroup value={option} onChange={(e) => handleOptionChange(e.target.value)}>
                    <FormControlLabel value="context1" control={<Radio/>} label="Cargue notificación glosa" />
                    <FormControlLabel  value="context2" control={<Radio/>} label="Cargue de soportes" />
                </RadioGroup>
            </Box>
            <>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, width: '80%', mb:1 , mt:1 }}>
                <Select
                value={selectedField}
                onChange={(e) => setSelectedField(e.target.value)}
                label="Entidad asociada"
                displayEmpty
                sx={{
                    color: selectedField ? 'black' : '#444',
                    backgroundColor: "white",
                    border: "1px solid #ccc",
                    borderRadius: "8px", 
                    "& .MuiSelect-select": { 
                        padding: "10px", 
                        fontSize: "16px"
                    },
                    "&:hover": { 
                        borderColor: "#666" 
                    },
                    "&.Mui-focused": { 
                        borderColor: "#1976d2" 
                    }
                }}>
                    <MenuItem value="" disabled sx={{ color: "#444" }}>Seleccione una entidad</MenuItem>
                    {entidades.map((entidad) => (
                        <MenuItem key={entidad.id} value={entidad.id} sx={{fontSize: "14px", "&:hover": { backgroundColor: "#e3f2fd" }}}> 
                            {entidad.nombre_cliente}
                        </MenuItem>
                    ))}
                </Select>
            </Box>
                            
            <Typography variant="subtitle1" sx={{ fontWeight: 'bold'}} gutterBottom>
                Subir Archivos PDF
            </Typography>
            <input
                type="file"
                accept=".pdf"
                multiple
                onChange={handleFileChange}
                style={{ margin: '5px 0', bgcolor: 'secondary' }}/>
            {selectedFiles.length > 0 && (
                <List dense sx={{ maxHeight: selectedFiles.length > 3 ? '160px' : 'auto', overflowY: 'auto', border: selectedFiles.length > 3 ? '1px solid #ddd' : 'none' }}>
                    {selectedFiles.map((file, index) => (
                        <ListItem
                            key={index}
                            secondaryAction={
                                <IconButton edge="end" aria-label="delete" onClick={() => handleFileDelete(file.name)}>
                                    <DeleteIcon />
                                </IconButton>
                            }
                        >
                            <ListItemText primary={file.name} />
                        </ListItem>
                    ))}
                </List>
            )}
            </>
        
            {uploadStatus && (
                <Typography variant="body2" color="error" gutterBottom>
                    {uploadStatus}
                </Typography>
            )}
            <Button
                variant="contained"
                color="secondary"
                onClick={handleFileUpload}
                disabled={selectedFiles.length === 0 || isUploading}
                sx={{ mt: 2, mb:2, alignItems:'end'}}
            >
                {isUploading ? 'Subiendo' : 'Subir Archivos'}
            </Button>
            
            <ProgressBarModal open={openModalBar} duration={(selectedFiles.length * 1000) + 3000}
                progreso={uploadProgress}
                message={message}
                snackbarMessage={snackbarMessage} 
                severity={snackbarSeverity}
                onClose={() => setOpenModalBar(false)}/>
        </Box>
    );
};

export default FileUpload;
